import React from "react";

const DashboardLogo = (props) => {
  const { expandState, dashLayout } = props;
  return (
    <div className={`dashboard-logo ${expandState && 'remove-padding'}`}
    >
      {expandState || dashLayout ? (
          <img
            src={require("assets/images/dashboard-gdi-logo.png").default}
            className="img-fluid"
            alt="logo"
          />
      ) : (
        <img
          src={require("assets/images/logo.png").default}
          className="img-fluid"
          alt="logo"
        />
      )}
    </div>
  );
};

export default DashboardLogo;
